// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { DisclaimerTooltip } from '../tooltips';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import { DISCLAIMER_LEVEL, DISCLAIMER_KEYS } from '../../../utils/disclaimers/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';
import NoDataText from '@/types/no-data-text';

type Props = {
  className?: string;
  disclaimerKey?: string;
  id?: string;
  item?: ComparisonItem;
  onClick?: (event: React.MouseEvent) => void;
  locale?: Locale;
  noDataText?: NoDataText;
};

const NoDataCell: React.FC<Props> = ({ className, disclaimerKey, item, onClick, id, locale, noDataText = 'NotApplicable' }) => {
  const getDisclaimerKey = () => {
    if (disclaimerKey && item?.disclaimers?.[disclaimerKey]) {
      return item.disclaimers[disclaimerKey];
    }

    if (disclaimerKey && DISCLAIMER_KEYS[disclaimerKey]) {
      return { key: DISCLAIMER_KEYS[disclaimerKey] };
    }

    return { key: DISCLAIMER_KEYS.DEFAULT_MISSING_DATA };
  };

  const cellProps = {
    className: classNames(className, 'cell no-data-cell'),
    onClick,
    id: id ? `cell-${id}` : undefined,
  };

  return (
    <div {...cellProps}>
      <span className="markup-container">
        {noDataText === NoDataText.NotApplicable && <FormattedMessage id="Common.NotApplicable" locale={locale} />}
        {noDataText === NoDataText.Dash && <span>-</span>}
        {noDataText === NoDataText.NotApplicable && (
          <DisclaimerTooltip disclaimer={getDisclaimerKey()} levelOverride={DISCLAIMER_LEVEL.INFO} className="no-print" />
        )}
      </span>
    </div>
  );
};

export default NoDataCell;
